import { Videocam } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { hireflixCta, hireflixCtaHover } from '@styles/colors';
import { FC, useState } from 'react';

import HireflixPlanPurchaseModal from '../HireflixPlanPurchaseModal/HireflixPlanPurchaseModal';

type HireflixLowCreditModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  invitesCount?: number;
  creditsLeft?: number;
  onConfirmSend?: () => void;
};

const HireflixLowCreditModal: FC<HireflixLowCreditModalProps> = ({
  isOpen,
  handleClose,
  invitesCount,
  creditsLeft,
  onConfirmSend,
}) => {
  const [hireflixPlanModal, setHireflixPlanModal] = useState(false);

  const handleHireflixPlanModal = () => {
    setHireflixPlanModal(!hireflixPlanModal);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        <br />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '64px',
            height: '64px',
            margin: '0 auto',
            borderRadius: '100%',
            backgroundColor: 'rgb(243, 232, 255)',
            mb: 1,
          }}
        >
          <Videocam sx={{ fontSize: 40, color: hireflixCta }} />
        </Box>

        <Typography variant="h4" sx={{ p: 3 }}>
          Almost Out of Interview Credits
          <Typography color="text.secondary">
            Add credits before you send your invites
          </Typography>
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 3, textAlign: 'center' }}>
          {!invitesCount && (
            <>
              Your interview invite has been sent successfully! However,
              you&apos;re running low on HireFlix interview credits.
            </>
          )}
          {invitesCount && (
            <span>
              You’re about to send <strong>{invitesCount}</strong> interview
              invite{invitesCount > 1 ? 's' : ''}, but you only have{' '}
              <strong>{creditsLeft ?? '0'}</strong> credit
              {(creditsLeft ?? 0) > 1 ? 's' : ''} left. Would you like to add
              more credits before sending your invites?
            </span>
          )}
        </Typography>

        <Stack spacing={2} width="100%" alignItems="end" sx={{ mt: 5 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleHireflixPlanModal}
            sx={{
              backgroundColor: hireflixCta,
              '&:hover': {
                backgroundColor: hireflixCtaHover,
              },
            }}
          >
            Add Credits Now
          </Button>

          {onConfirmSend && (
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                handleClose();
                onConfirmSend();
              }}
            >
              Send & Add Credits Later
            </Button>
          )}
        </Stack>
      </DialogContent>

      {/* Hireflix Plan Purchase Modal */}
      {hireflixPlanModal && (
        <HireflixPlanPurchaseModal
          isOpen={hireflixPlanModal}
          handleClose={handleHireflixPlanModal}
        />
      )}
    </Dialog>
  );
};

export default HireflixLowCreditModal;
